export default {
  title: {
    en: 'Product add-ons, at a discount',
  },
}
